import { z } from 'zod';
import { IdSchema } from './common.js';
/** The longest question one "Ask this project" call accepts. */
export const ASK_QUESTION_MAX_CHARS = 1000;
/** POST /projects/:id/ask — a question answered from the project's PRD, TDD, tasks, comments
 * and blockers (retrieval over projects/{id}/ragChunks; see docs/PLAN.md §5.5). */
export const AskProjectInputSchema = z.object({
    question: z.string().trim().min(1).max(ASK_QUESTION_MAX_CHARS),
});
/** What a retrieved excerpt came from — decides where the UI links a citation to. */
export const ASK_SOURCE_KINDS = ['prd', 'tdd', 'task', 'comment', 'issue'];
export const AskSourceKindSchema = z.enum(ASK_SOURCE_KINDS);
/** One excerpt the answer cites. `n` is the number the answer refers to it by ("[3]"). */
export const AskSourceSchema = z.object({
    n: z.number().int().positive(),
    kind: AskSourceKindSchema,
    label: z.string(),
    /** Set for task, comment and issue excerpts — the task page the citation links to. */
    taskId: IdSchema.nullable(),
});
/** jobs/{jobId}.result for a `project_ask` job. Only the excerpts the answer actually cites. */
export const AskProjectResultSchema = z.object({
    answer: z.string(),
    sources: z.array(AskSourceSchema),
});
//# sourceMappingURL=ask.js.map